'use strict';

function dateIsValid(d) {
  return !isNaN(d.getTime());
}

module.exports = dateIsValid;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/dateIsValid.js
// module id = 59
// module chunks = 0